/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Profile_Tech_Skills_PlaceholderInputs */

const en_candidate_profile_tech_skills_placeholder = /** @type {(inputs: Candidate_Profile_Tech_Skills_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g., JavaScript, Python, SQL`)
};

const de_candidate_profile_tech_skills_placeholder = /** @type {(inputs: Candidate_Profile_Tech_Skills_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. JavaScript, Python, SQL`)
};

/**
* | output |
* | --- |
* | "e.g., JavaScript, Python, SQL" |
*
* @param {Candidate_Profile_Tech_Skills_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_profile_tech_skills_placeholder = /** @type {((inputs?: Candidate_Profile_Tech_Skills_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Profile_Tech_Skills_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_profile_tech_skills_placeholder(inputs)
	return en_candidate_profile_tech_skills_placeholder(inputs)
});